export default __webpack_public_path__ + "static/src/companys/ttl/assets/images/icons/marketdetail_indicator_icon_blue.png";